/*** IMPORTS FROM imports-loader ***/
var global = window;

module.exports = {
  "version": "0.27.2"
};
